import React from 'react';
import './how-it-works.scss';
import cn from 'classnames';
import {HOW_IT_WORKS_BLOCKS} from '../how_it_works_information';
import {Carousel} from '../../../components/carousel';
import {useIsDesktop} from '../../../hooks';
import {handleClickToLink} from '../../../utils/yandex_counter';

function HowItWorks() {
    const isSlider = !useIsDesktop();
    const presentations = HOW_IT_WORKS_BLOCKS.map(({text, img, extra, link, ref}) => {
        return (
            <div className="how-it-works__presentation" key={img}>
                <div className={cn('how-it-works__img', img)}/>
                <div className="how-it-works__text">{text}</div>
                {extra !== null && (
                    <div className="how-it-works__extra">
                        {extra}
                        {link && (
                            <a href={ref} rel="noopener noreferrer" target="_blank" onClick={handleClickToLink}>
                                {link}
                            </a>
                        )}
                    </div>
                )}
            </div>
        );
    });
    return (
        <div className="how-it-works">
            <div className="how-it-works__header">Как мы гарантируем неизменность данных</div>
            {!isSlider && <div className="how-it-works__info">{presentations}</div>}
            {isSlider && (
                <div className="how-it-works__slider">
                    <Carousel dotsClass="how-it-works__extradots">
                        {presentations.map((el, index) => (
                            <div key={index}>{el}</div>
                        ))}
                    </Carousel>
                </div>
            )}
        </div>
    );
}

export {HowItWorks};
